export default __webpack_public_path__ + "static/ProValue_6@768-273d24e12412ef1284ed54a71b8b16e3.webp";